import Navbar from "../../components/Navbar"
import DashboardContainer from "../Dashboard/DashboardContainer"
import DocumentComponent from "./component/DocumentComponent"
import document from "../../assets/Images/tempImg/documentImage.png"
import { useState } from "react"
import Modal from "../../components/Modal"
import DocumentIcon2 from "../../assets/Icons/DocumentIcon2"
import CloseIcon from "../../assets/Icons/CloseIcon"
import DeleteIcon from "../../assets/Icons/DeleteIcon";
import pdfDoc from "../../assets/Minutes of Meeting.docx.pdf";
import Headings from "../../components/Texts/Headings"
const Documents = () => {
  const [modalStates, setModalStates] = useState({
    modalvisible: false,
    selectedDoc: {}
  });

  const [documentStates, setDocumentStates] = useState({
    document1: {
      text: "Pan Card",
      documents: [
        {
          type: "Pan Card",
          img: document,
          view: "image",
          uplaodDate: "24/5/2020",
          size: "1.0 MB",
        }]
    },
    document2: {
      text: "Aadhar Card",
      documents: [
        {
          type: "Aadhar Card",
          img: document,
          view: "pdf",
          uplaodDate: "24/5/2020",
          size: "1.0 MB",
        }
      ]
    }
  })

  const stateUpdateHandler = (key, value) => {
    setModalStates((prev) => ({
      ...prev,
      [key]: value
    }))
  }

  const imageSelectHandler = image => {
    stateUpdateHandler("image", image);
    modalToggle();
  }

  const modalToggle = () => {
    stateUpdateHandler("modalvisible", !modalStates?.modalvisible);
  }

  return (
    <>
      <Navbar isLoggedIn={true} />
      <DashboardContainer>
        <Headings
          text="My Account"
        />

        <div className="flex flex-col mt-[20px] md:mt-[60px] gap-[30px]">
          <DocumentComponent {...documentStates?.document1} imageSelectHandler={imageSelectHandler} stateUpdateHandler={stateUpdateHandler} />
          <DocumentComponent {...documentStates?.document2} imageSelectHandler={imageSelectHandler} stateUpdateHandler={stateUpdateHandler} />
        </div>
        <Modal visible={modalStates?.modalvisible} onClose={modalToggle} >
          <div
            className="bg-white rounded-[16px] overflow-hidden"
            style={{
              width: modalStates?.selectedDoc?.view === "pdf" ? "sm:280px md:600px lg:1000px" : "auto",
              height: modalStates?.selectedDoc?.view === "pdf" ? "80vh" : "auto",
            }}
          >
            <div className="flex justify-between bg-white
          rounded-t-[16px] px-[16px]  py-[8px] items-center
          border-b-[1px]
          border-b-[#424952]
          ">
              <div className="flex gap-[10px] items-center">
                <DocumentIcon2 />
                <p className="font-Apparat font-[500] md:font-[600] text-[14px] md:text-[20px] text-black">{modalStates?.selectedDoc?.type}</p>
              </div>
              <div className="flex gap-[16px]">
                <DeleteIcon h="16" w="16" />
                <CloseIcon h="16" w="16" onClick={modalToggle} />
              </div>
            </div><div
              className="p-[24px] bg-[#F8F8F8] rounded-b-[16px]"
            >
              {modalStates?.selectedDoc?.view == "image" && <img src={modalStates?.selectedDoc?.img} />}
              {modalStates?.selectedDoc?.view == "pdf" && <iframe
                src={`${pdfDoc}#page=1&zoom=100&toolbar=0&navpanes=0&scrollbar=0`}
                className="w-full h-full"
                style={{ minHeight: "60vh", maxHeight: "80vh" }}
                frameBorder="0"
                title="PDF Viewer"
              ></iframe>}
            </div>
          </div>
        </Modal>
      </DashboardContainer>
    </>
  )
}

export default Documents